export const typeDefs = `
  union ArchivedSelfConsumptionRewardSortType = date | platformName | return | membershipReward | consumptionReward | totalReward

  input ArchivedSelfConsumptionRewardFilterInput {
    date: [String]
    platformId: String,
    return: [Float]
    membershipReward: [Float]
    consumptionReward: [Float]
    totalReward: [Float]
  }

  union ArchivedTeamConsumptionRewardSortType = date | platformName | return | membershipReward | consumptionReward | extraReward | totalReward

  input ArchivedTeamConsumptionRewardFilterInput {
    date: [String]
    platformId: String,
    return: [Float]
    membershipReward: [Float]
    consumptionReward: [Float]
    extraReward: [Float]
    totalReward: [Float]
  }

  union ArchivedMerchantReferralRewardSortType = date | platformName | totalReward

  input ArchivedMerchantReferralRewardFilterInput {
    date: [String]
    platformId: String,
    totalReward: [Float]
  }

  union ArchivedDepositRewardSortType =
  date
  | amount
  | return
  | returnedReward
  | overflowReward
  | extraReward
  | totalReward

  input ArchivedDepositRewardFilterInput {
    date: [String]
    amount: [Float]
    return: [Float]
    returnedReward: [Float]
    overflowReward: [Float]
    extraReward: [Float]
    totalReward: [Float]
  }
`;
